import { StringParam, useQueryParams, withDefault } from 'use-query-params';

import { APPLE_FILTER_KEY } from '@insights_module/constants/contextualAndEntity';
import { AppleParamsType } from '@insights_module/types/ContextualAndEntity';

export const useAppleParams = () => {
  const [query, setQuery] = useQueryParams({
    [APPLE_FILTER_KEY.arts]: withDefault(StringParam, 'ignore'),
    [APPLE_FILTER_KEY.business]: withDefault(StringParam, 'ignore'),
    [APPLE_FILTER_KEY.comedy]: withDefault(StringParam, 'ignore'),
    [APPLE_FILTER_KEY.education]: withDefault(StringParam, 'ignore'),
    [APPLE_FILTER_KEY.fiction]: withDefault(StringParam, 'ignore'),
    [APPLE_FILTER_KEY.government]: withDefault(StringParam, 'ignore'),
    [APPLE_FILTER_KEY.history]: withDefault(StringParam, 'ignore'),
    [APPLE_FILTER_KEY.health_and_fitness]: withDefault(StringParam, 'ignore'),
    [APPLE_FILTER_KEY.kids_and_family]: withDefault(StringParam, 'ignore'),
    [APPLE_FILTER_KEY.leisure]: withDefault(StringParam, 'ignore'),
    [APPLE_FILTER_KEY.music]: withDefault(StringParam, 'ignore'),
    [APPLE_FILTER_KEY.news]: withDefault(StringParam, 'ignore'),
    [APPLE_FILTER_KEY.religion_and_spirituality]: withDefault(StringParam, 'ignore'),
    [APPLE_FILTER_KEY.science]: withDefault(StringParam, 'ignore'),
    [APPLE_FILTER_KEY.society_and_culture]: withDefault(StringParam, 'ignore'),
    [APPLE_FILTER_KEY.sports]: withDefault(StringParam, 'ignore'),
    [APPLE_FILTER_KEY.technology]: withDefault(StringParam, 'ignore'),
    [APPLE_FILTER_KEY.true_crime]: withDefault(StringParam, 'ignore'),
    [APPLE_FILTER_KEY.tv_and_film]: withDefault(StringParam, 'ignore'),
  });

  const params = Object.keys(query);

  const resetAppleParams = () => {
    params.forEach((param) => {
      setQuery(
        {
          [param]: undefined,
        },
        'pushIn'
      );
    });
  };

  const setAllAppleParams = (params: AppleParamsType) => {
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        setQuery(
          {
            [key]: value,
          } as { [key: string]: string },
          'pushIn'
        );
      });
    }
  };

  return { appleParams: query, setAppleParams: setQuery, resetAppleParams, setAllAppleParams };
};
